module.exports = __webpack_public_path__ + "img/security.6b9a191.svg";